export const BLUE = "#0066ff";
export const GREEN = "#4aa58b";
export const PURPLE = "#6c00ff";
export const RED = "#ff6b42";
export const YELLOW = "#ffc733";
export const LIGHT_YELLOW = "#fff7c0";
export const DARK_YELLOW = "#a78400";
export const BLACK = "#222";
